import { inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserFacade } from '@app/store/user';

import { AccountFacade } from '@corelabs/angular/account';
import { MessageService } from '@corelabs/angular/messages';
import { TranslateService } from '@ngx-translate/core';
import { filter, Subscription, tap, throttleTime } from 'rxjs';

@Injectable()
export class AccountSessionExpiredService implements OnDestroy {
    private readonly accountFacade = inject(AccountFacade);
    private readonly router = inject(Router);
    private readonly messageService = inject(MessageService);
    private readonly translateService = inject(TranslateService);
    private readonly userFacade = inject(UserFacade);

    private subscriptions$ = new Subscription();

    constructor() {
        this.subscriptions$.add(
            this.accountFacade.sessionExpired$
                .pipe(
                    filter((value) => value === true),
                    throttleTime(1000),
                    tap(() => this.handleSessionExpired()),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }

    private handleSessionExpired() {
        this.messageService.add(this.translateService.instant('account.error.session-expired'), 'danger');
        this.userFacade.clear();
        this.router.navigateByUrl('/auth/sign-in', { replaceUrl: true });
    }
}
